import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import logoMain from "../Assets/logos/logo.png";
import { ApiList } from "../Config/ApiList";
import PathList from "../Common/PathList";
import AxiosInstance from "../Config/AxiosInstance";
import CustomTextField from "../Components/CustomTextField";
import toast from "react-hot-toast";
const LoginScreen = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [forgotpassword, setrForgotpassword] = useState(false);
  useEffect(() => {
    let userinfo;
    try {
      userinfo = JSON.parse(localStorage.getItem("PLAYER_SCOUT"));
    } catch (error) {
      userinfo = null;
    }
    if (userinfo) {
      return navigate(PathList.ManageClub);
    }
  }, []);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().required("Email address is required!"),
      password: Yup.string()
        .required("Password is required!")
        .min(6, "Password must be at least 6 characters")
        .max(20, "Password must be at most 20 characters"),
    }),

    onSubmit: async (values, { resetForm }) => {
      try {
        setIsLoading(true);
        const params = {
          email: values.email,
          password: values.password,
          role: 1,
        };
        const response = await AxiosInstance.post(ApiList.LOGIN, params);
        if (response && response?.data?.s === 1) {
          if (response?.data?.r?.role === 1) {
            localStorage.setItem("PLAYER_SCOUT", JSON.stringify(response?.data?.r));
            navigate(PathList.Dashboard);
            toast.success("Login Successfully.");
            resetForm();
          } else {
            toast.error("You Are Not Authenticated");
          }
        } else {
          toast.error("Please enter a valid Email or Password", {
            style: {
              width: "100%",
              whiteSpace: "nowrap",
              minWidth: "fit-content",
            },
          });
          resetForm();
        }
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data?.message || error?.message || "An error occurred");
      } finally {
        setIsLoading(false);
      }
    },
  });

  const handleForgotClick = () => {
    setrForgotpassword(true);
    formik.resetForm();
    ForgotPasswordValidation.resetForm();
  };

  const ForgotPasswordValidation = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().required("Email address is required!"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        setIsLoading(true);
        const params = {
          email: values.email,
          role: 2,
        };
        const response = await AxiosInstance.post(
          ApiList.FORGOT_PASSWORD,
          params
        );
        if (response && response?.data?.s === 1) {
          toast.success(response.data.m);
          resetForm();
        } else {
          toast.error("Email is not exists");
          resetForm();
        }
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data?.message || error?.message || "An error occurred");
      } finally {
        setIsLoading(false);
      }
    },
  });
  return (
    <>
      <Box
        sx={{
         background:"#000938"
        }}
      >
        <Box
          sx={{
            width: "90%",
            marginX: "auto",
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
          }}
        >
          <Box
            sx={{
              maxWidth: "500px",
              // maxHeight: "calc(100vh - 100px)",
              background: "#ffffff",
              p: 4,
              borderRadius: "32px",
              // overflow: "scroll",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                mb: "10px",
              }}
            >
            
            </Box>
            <Typography
              sx={{
                color: "#000938",
                fontWeight: "500",
                fontSize: "28px",
                textAlign: "center",
              }}
            >
              {forgotpassword ? "Forgot Password?" : "Welcome Back!"}
            </Typography>
            <Typography
              sx={{
                color: "#00000070",
                fontWeight: "400",
                fontSize: "14px",
                textAlign: "center",
              }}
            >
              {forgotpassword
                ? "Enter your email to get reset your password."
                : "Access your admin dashboard to manage users, challenges, reports, and more. Stay in control with powerful tools at your fingertips."}
            </Typography>
            {forgotpassword ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  mt: 3,
                }}
              >
                <CustomTextField
                  placeholder={"Enter email"}
                  title={"Email Address"}
                  type={"text"}
                  name={"email"}
                  value={ForgotPasswordValidation?.values?.email}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (value.trimStart() !== value) {
                      e.target.value = value.trimStart();
                    }
                    ForgotPasswordValidation.handleChange(e);
                  }}
                  onBlur={ForgotPasswordValidation?.handleBlur}
                  errors={
                    ForgotPasswordValidation?.touched?.email &&
                    ForgotPasswordValidation?.errors?.email
                  }
                />
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    gap: "12px",
                    justifyContent: "space-evenly",
                  }}
                >
                  <Button
                    type="submit"
                    onClick={() => ForgotPasswordValidation?.handleSubmit()}
                    sx={{
                      textTransform: "none",
                      background:
                        "#000938",
                      color: "#ffffff",
                      borderRadius: "8px",
                      width: "100%",
                    }}
                  >
                    {ForgotPasswordValidation.isSubmitting ? (
                      <CircularProgress size={22} color="inherit" />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                  <Button
                    onClick={() => setrForgotpassword(false)}
                    sx={{
                      textTransform: "none",
                      background: "#00000020",
                      color: "#000000",
                      borderRadius: "8px",
                      width: "100%",
                    }}
                  >
                    Back
                  </Button>
                </Box>
              </Box>
            ) : (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    mt: 3,
                  }}
                >
                  <CustomTextField
                    placeholder={"Enter email"}
                    title={"Email Address"}
                    type={"text"}
                    name={"email"}
                    value={formik?.values?.email}
                    onChange={(e) => {
                      const { value } = e.target;
                      if (value.trimStart() !== value) {
                        e.target.value = value.trimStart();
                      }
                      formik.handleChange(e);
                    }}
                    onBlur={formik?.handleBlur}
                    errors={formik?.touched?.email && formik?.errors?.email}
                  />
                  <CustomTextField
                    placeholder={"Enter password"}
                    title={"Password"}
                    type={"password"}
                    name={"password"}
                    value={formik?.values?.password}
                    onChange={(e) => {
                      const { value } = e.target;
                      if (value.trimStart() !== value) {
                        e.target.value = value.trimStart();
                      }
                      formik.handleChange(e);
                    }}
                    onBlur={formik?.handleBlur}
                    errors={
                      formik?.touched?.password && formik?.errors?.password
                    }
                  />
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    <Typography
                      onClick={handleForgotClick}
                      sx={{
                        color: "#000000",
                        textDecoration: "none",
                        cursor: "pointer",
                        fontSize: "14px",
                        my: 1,
                      }}
                    >
                      Forgot Password?
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    type="submit"
                    onClick={() => formik?.handleSubmit()}
                    sx={{
                      width: "150px",
                      textTransform: "none",
                      background:
                        "#000938",
                      color: "#ffffff",
                      borderRadius: "8px",
                    }}
                  >
                    {formik.isSubmitting ? (
                      <CircularProgress size={22} color="inherit" />
                    ) : (
                      "Login"
                    )}
                  </Button>
                </Box>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default LoginScreen;
